import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getCommentsState = (state: RootState) => state.postComments;

export const selectComments = (postId: string) =>
  createSelector([getCommentsState], (commentState) =>
    commentState.comments[postId]?.data.slice().reverse()
  );

export const selectLoadingComments = (postId: string) =>
  createSelector([getCommentsState], (commentState) =>
    Boolean(commentState.loadingComments[postId])
  );

export const selectRepliesToComment = (replyId: string) =>
  createSelector([getCommentsState], (commentState) =>
    commentState.repliesToComment[replyId]?.data.slice().reverse()
  );

export const selectLoadingRepliesToComment = (replyId: string) =>
  createSelector([getCommentsState], (commentState) =>
    Boolean(commentState.loadingRepliesToComment[replyId])
  );

export const selectHasMoreComments = (postId: string) =>
  createSelector([getCommentsState], (commentState) =>
    Boolean(commentState.comments[postId]?.xMsContinuationToken)
  );

export const selectCommentsContinuationToken = (postId: string) =>
  createSelector(
    [getCommentsState],
    (commentState) => commentState.comments[postId]?.xMsContinuationToken
  );

export const selectRepliesToCommentContinuationToken = (replyId: string) =>
  createSelector(
    [getCommentsState],
    (commentState) =>
      commentState.repliesToComment[replyId]?.xMsContinuationToken
  );

export const selectHasMoreRepliesToComment = (replyId: string) =>
  createSelector([getCommentsState], (commentState) =>
    Boolean(commentState.repliesToComment[replyId]?.xMsContinuationToken)
  );

export const selectLoadingCreateComment = (postId?: string) =>
  createSelector([getCommentsState], (commentState) =>
    postId ? Boolean(commentState.loadingCreateComment[postId]) : false
  );

export const selectLoadingCreateReplyToComment = (commentId?: string) =>
  createSelector([getCommentsState], (commentState) =>
    commentId
      ? Boolean(commentState.loadingCreateReplyToComment[commentId])
      : false
  );

export const selectIsStickyKeyboardShown = createSelector(
  [getCommentsState],
  (commentState) => commentState.isStickyKeyboardShown
);

export const selectSelectedComment = createSelector(
  [getCommentsState],
  (commentState) => commentState.selectedComment
);

export const selectSelectedCommentLoading = createSelector(
  [getCommentsState],
  (commentState) => commentState.selectedCommentLoading
);

export const selectSelectedCommentError = createSelector(
  [getCommentsState],
  (commentState) => commentState.selectedCommentError
);

export const selectEditedReply = createSelector(
  [getCommentsState],
  (commentState) => commentState.editedReply
);

export const selectLoadingUpdateComment = (postId?: string) =>
  createSelector([getCommentsState], (commentState) =>
    postId ? Boolean(commentState.loadingUpdateComment[postId]) : false
  );

export const selectModerationReasons = createSelector(
  [getCommentsState],
  (commentState) => commentState.moderationReasons
);
